import { l as lib } from '../../../3rdPartyModules/split-graphemes/lib/index-CQH2gKIH.js';

const getCharactersCount = str => lib.splitGraphemes(str).length;

export { getCharactersCount as g };
//# sourceMappingURL=getCharactersCount-D5D88kic.js.map
